import { render } from "./AddMoyenPaiementModal.vue?vue&type=template&id=a20c2836&ts=true"
import script from "./AddMoyenPaiementModal.vue?vue&type=script&lang=ts"
export * from "./AddMoyenPaiementModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__